<template>
  <div class="filters" :class="{ 'details-layout': detailsLayout }">
    <div class="filter">
      <div class="filter_item filter_range" v-if="visible.date">
        <div class="wrap_titler">
          <div class="titler">Выберите период</div>
          <div v-if="hasDate" class="clear" @click="clearDate">
            <Icon name="close" />
          </div>
        </div>

        <v-menu
          v-model="menuDate"
          :close-on-content-click="false"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="rel" v-bind="attrs" v-on="on">
              <v-text-field
                v-model="rangeText"
                readonly
                class="input_custom input_range"
                hide-details
                height="40"
                dense
              />
              <Icon class="abs" name="calendar" />
            </div>
          </template>
          <v-card class="pa-2 picker-card">
            <!-- оставляем header-color="white", чтобы фон был белым -->
            <v-date-picker
              v-model="dateRange"
              locale="ru"
              :first-day-of-week="1"
              range
              color="#4B5EFF"
              header-color="white"
              light
              :show-current="true"
              class="picker-fix"
              @change="saveDate"
            />
            <div class="d-flex mt-2" v-if="!dateOnly">
              <v-text-field
                v-model="filters.startTime"
                type="time"
                hide-details
                dense
                class="mr-2 time-field"
              />
              <v-text-field
                v-model="filters.endTime"
                type="time"
                hide-details
                dense
                class="time-field"
              />
            </div>
            <v-btn block class="ok-btn mt-2" @click="saveDate">OK</v-btn>
          </v-card>
        </v-menu>
      </div>
      <div class="filter_item" v-if="visible.calls">
        <div class="wrap_titler">
          <div class="titler">{{ callsTitle }}</div>
          <div
            v-if="filters.current_call"
            class="clear"
            @click="filters.current_call = ''"
          >
            <Icon name="close" />
          </div>
        </div>
        <v-autocomplete
          class="input_custom_call"
          v-model="filters.current_call"
          :items="visible.calls"
          item-text="name"
          item-value="guid"
          :multiple="visible.callsMultiple"
          :chips="visible.callsMultiple"
          :deletable-chips="visible.callsMultiple"
          solo
          :no-data-text="callsNoDataText"
          :placeholder="callsPlaceholder"
          color="#4B5EFF"
          height="40"
          hide-details
          error-count="0"
          width="450"
        >
          <template
            v-slot:selection="{ index }"
            v-if="Array.isArray(filters.current_call)"
          >
            <span v-if="index === 0">
              <!-- <template v-if="!filters.current_call || filters.current_call.length === 0">Выберите обзвон</template>
            <template v-else-if="filters.current_call.length === 1">{{ filters.current_call[0] }}</template> -->
              <template>Выбрано {{ filters.current_call.length }}</template>
            </span>
          </template>
          <template v-slot:no-data>
            <div class="no-data-plank">Обзвонов нет</div>
          </template>
        </v-autocomplete>
      </div>
      <div class="filter_item" v-if="visible.scripts">
        <div class="wrap_titler">
          <div class="titler">Выберите скрипт</div>
          <div
            v-if="filters.current_script"
            class="clear"
            @click="filters.current_script = null"
          >
            <Icon name="close" />
          </div>
        </div>
        <v-autocomplete
          class="input_custom_script"
          v-model="filters.current_script"
          :items="visible.scripts"
          item-text="name"
          item-value="guid"
          :multiple="visible.callsMultiple"
          :chips="visible.callsMultiple"
          :deletable-chips="visible.callsMultiple"
          :return-object="false"
          solo
          placeholder="Выберите скрипт"
          no-data-text="Скриптов нет"
          color="#4B5EFF"
          height="40"
          hide-details
          error-count="0"
          width="450"
          :menu-props="{ offsetY: true }"
        >
          <template v-slot:selection="{ index }" v-if="visible.callsMultiple">
            <span v-if="index === 0">
              <!-- <template v-if="Array.isArray(filters.current_script) && filters.current_script.length === 1">
              {{ item.name }}
            </template> -->
              <template>
                Выбрано
                {{
                  Array.isArray(filters.current_script)
                    ? filters.current_script.length
                    : 0
                }}
              </template>
            </span>
          </template>
        </v-autocomplete>
      </div>

      <div class="filter_item" v-if="visible.phone">
        <div class="wrap_titler">
          <div class="titler">Поиск по номеру</div>
          <div v-if="filters.search" class="clear" @click="filters.search = ''">
            <Icon name="close" />
          </div>
        </div>
        <div class="search rel">
          <v-text-field
            v-model="filters.search"
            type="tel"
            class="input_custom"
            placeholder="Введите номер"
            error-count="0"
            height="40"
            v-maska="maskaFilter"
            :hide-details="true"
          ></v-text-field>
          <div class="abs search_btn">
            <Icon name="search" />
          </div>
        </div>
      </div>

      <div class="filter_item" v-if="visible.text">
        <div class="wrap_titler">
          <div class="titler">Поиск по фразе</div>
          <div v-if="filters.text" class="clear" @click="filters.text = ''">
            <Icon name="close" />
          </div>
        </div>
        <div class="search rel">
          <v-text-field
            v-model="filters.text"
            type="text"
            class="input_custom"
            placeholder="Введите фразу"
            error-count="0"
            height="40"
            v-maska="''"
            :hide-details="true"
          ></v-text-field>
          <div class="abs search_btn">
            <Icon name="search" />
          </div>
        </div>
      </div>

      <div class="filter_item" v-if="visible.nickname">
        <div class="wrap_titler">
          <div class="titler">Поиск по псевдониму</div>
          <div
            v-if="filters.searchNickname"
            class="clear"
            @click="filters.searchNickname = ''"
          >
            <Icon name="close" />
          </div>
        </div>
        <div class="search rel">
          <v-text-field
            v-model="filters.searchNickname"
            type="tel"
            class="input_custom"
            placeholder="Введите псевдоним"
            error-count="0"
            height="40"
            v-maska="''"
            :hide-details="true"
          ></v-text-field>
          <div class="abs search_btn">
            <Icon name="search" />
          </div>
        </div>
      </div>

      <div class="filter_item" v-if="visible.visible">
        <div class="wrap_titler">
          <div class="titler">Поиск по менеджеру</div>
          <div
            v-if="filters.searchManager"
            class="clear"
            @click="filters.searchManager = ''"
          >
            <Icon name="close" />
          </div>
        </div>
        <div class="search rel">
          <v-text-field
            v-model="filters.searchManager"
            type="tel"
            class="input_custom"
            placeholder="Введите псевдоним"
            error-count="0"
            height="40"
            v-maska="''"
            :hide-details="true"
          ></v-text-field>
          <div class="abs search_btn">
            <Icon name="search" />
          </div>
        </div>
      </div>

      <div class="filter_item" v-if="visible.target">
        <div class="wrap_titler">
          <div class="titler">Цель</div>
          <div v-if="filters.target" class="clear" @click="filters.target = ''">
            <Icon name="close" />
          </div>
        </div>
        <v-combobox
          class="input_custom_target"
          v-model="filters.target"
          :items="visible.targets"
          multiple
          chips
          deletable-chips
          solo
          no-data-text="Целей нет"
          color="#4B5EFF"
          height="40"
          hide-details
          error-count="0"
          width="450"
        >
          <template v-slot:selection="{ index }">
            <span v-if="index === 0">
              <!-- <template v-if="filters.target.length === 1">{{ filters.target[0] }}</template> -->
              <template v-if="filters.target.length > 0"
                >Выбрано {{ filters.target.length }}</template
              >
            </span>
          </template>
        </v-combobox>
      </div>

      <div class="filter_item" v-if="visible.managerVisible">
        <v-checkbox
          v-model="filters.visibleManager"
          color="#4B5EFF"
          label="Не показывать скрытые"
        ></v-checkbox>
      </div>
      <div class="filter_actions">
        <div class="filter_item ml-4">
          <v-btn class="apply-btn ml-4" height="45" @click="filterUpdate()"
            >Применить</v-btn
          >
        </div>
        <div class="filter_item ml-2" v-if="showExport">
          <v-btn class="export-btn ml-2" height="45" @click="exportExcel()"
            >Экспорт</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from './SetIcon.vue';

export default {
  components: {
    Icon,
  },

  created() {
    this.$set(
      this.$vuetify.lang.locales.en.datePicker,
      'itemsSelected',
      '{0} выбрано',
    );
    this.$set(
      this.$vuetify.lang.locales.ru.datePicker,
      'itemsSelected',
      '{0} выбрано',
    );
    this.$vuetify.lang.current = 'ru';
  },
  watch: {
    'filters.current_call'(val) {
      if (Array.isArray(val) && val.length === 0) {
        this.filters.current_call = null;
      }
    },

    'filters.current_script'(val) {
      if (Array.isArray(val) && val.length === 0) {
        this.filters.current_script = null;
      }
    },
    'filters.target'(val) {
      if (Array.isArray(val) && val.length === 0) {
        this.filters.target = null;
      }
    },
  },
  computed: {
    hasDate() {
      return !!(this.filters.startDate && this.filters.endDate);
    },
    rangeText() {
      if (!this.filters.startDate || !this.filters.endDate) {
        return this.emptyRangeText;
      }
      const fmt = (d, t) => {
        const [y, m, day] = d.split('-');
        return `${day}.${m}.${y} ${t}:00`;
      };
      if (this.dateOnly) {
        const fmtOnlyDate = (d) => {
          const [y, m, day] = d.split('-');
          return `${day}.${m}.${y}`;
        };

        return (
          fmtOnlyDate(this.filters.startDate) +
          ' – ' +
          fmtOnlyDate(this.filters.endDate)
        );
      }
      return (
        fmt(this.filters.startDate, this.filters.startTime) +
        ' – ' +
        fmt(this.filters.endDate, this.filters.endTime)
      );
    },
    dateRangeText() {
      if (this.filters.rangePicker.length)
        return this.filters.rangePicker.join(' — ');
      return [];
    },
    maskaFilter() {
      return this.visible.maska ? this.visible.maska : '+7 (###) ###-##-##';
    },
  },

  methods: {
    saveDate() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.filters.startDate = this.dateRange[0];
        this.filters.endDate = this.dateRange[1];
        this.filters.rangePicker = [...this.dateRange];

        const startTime = this.filters.startTime || '00:00';
        const endTime = this.filters.endTime || '23:59';

        const localStart = new Date(
          `${this.filters.startDate}T${startTime}:00`,
        );
        const localEnd = new Date(`${this.filters.endDate}T${endTime}:00`);

        this.filters.selectedStartTime = localStart
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ');
        this.filters.selectedEndTime = localEnd
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ');
      } else {
        this.filters.startDate = null;
        this.filters.endDate = null;
        this.filters.rangePicker = [];

        this.filters.selectedStartTime = null;
        this.filters.selectedEndTime = null;
      }

      this.menuDate = false;
    },
    clearDate() {
      this.filters.rangePicker = [];
      this.dateRange = [];
      this.filters.startDate = '';
      this.filters.endDate = '';
      this.filters.startTime = '00:00';
      this.filters.endTime = '23:59';
      this.filters.utcStart = '';
      this.filters.utcFinish = '';

      this.filterUpdate();
    },

    handleStartTimeChange() {
      if (this.filters.rangePicker.length && this.filters.startTime) {
        const localDate = new Date(
          `${this.filters.rangePicker[0]}T${this.filters.startTime}`,
        );
        const utcOffset = localDate.getTimezoneOffset();
        const utcDate = new Date(localDate.getTime() + utcOffset * 60000);
        const formatted = `${utcDate.getFullYear()}-${(utcDate.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${utcDate
          .getDate()
          .toString()
          .padStart(2, '0')} ${utcDate
          .getHours()
          .toString()
          .padStart(2, '0')}:${utcDate
          .getMinutes()
          .toString()
          .padStart(2, '0')}:00`;
        this.filters.utcStart = formatted;
      }
    },

    handleEndTimeChange() {
      if (this.filters.rangePicker.length && this.filters.endTime) {
        const localDate = new Date(
          `${this.filters.rangePicker[1]}T${this.filters.endTime}`,
        );
        const utcOffset = localDate.getTimezoneOffset();
        const utcDate = new Date(localDate.getTime() + utcOffset * 60000);
        const formatted = `${utcDate.getFullYear()}-${(utcDate.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${utcDate
          .getDate()
          .toString()
          .padStart(2, '0')} ${utcDate
          .getHours()
          .toString()
          .padStart(2, '0')}:${utcDate
          .getMinutes()
          .toString()
          .padStart(2, '0')}:59`;
        this.filters.utcFinish = formatted;
      }
    },
    // clearSelectedTimeRange() {
    //   this.filters.utcStart = null;
    //   this.filters.utcFinish = null;
    //   this.filters.selectedStartTime = null;
    //   this.filters.selectedEndTime = null;
    // },
    exportExcel() {
      if (
        window.location.pathname === '/analytics' &&
        this.filters &&
        this.filters.rangePicker &&
        (!this.filters.rangePicker || this.filters.rangePicker.length === 0)
      ) {
        alert('Поле "Выберите период" не может быть пустым');
        return;
      }
      this.validateData();
      let selectGuid = null;
      const cleanGuid = (guid) =>
        guid.startsWith('call_') ? guid.substring(5) : guid;

      if (this.filters.current_call) {
        if (Array.isArray(this.filters.current_call)) {
          selectGuid = this.filters.current_call.map((item) => {
            const guid = item.guid || item;
            return cleanGuid(guid);
          });
        } else {
          const guid =
            this.filters.current_call.guid || this.filters.current_call;
          selectGuid = cleanGuid(guid);
        }
      }
      let filters = {
        select: selectGuid,
        target: this.filters.target,
        date: this.filters.rangePicker,
        search: this.filters.search,
        searchNickname: this.filters.searchNickname,
        searchManager: this.filters.searchManager,
        active_client: this.filters.visibleManager,
        selectedStartTime: this.filters.utcStart || null,
        selectedEndTime: this.filters.utcFinish || null,
        text: this.filters.text,
        script: this.filters.current_script
          ? this.filters.current_script.guid || this.filters.current_script
          : null,
      };
      this.$emit('exportExcel', filters);
    },
    validateData() {
      if (this.filters.rangePicker.length > 0) {
        if (this.filters.rangePicker.length == 1) {
          this.filters.rangePicker[1] = this.filters.rangePicker[0];
        }

        let start = new Date(this.filters.rangePicker[0]);
        let end = new Date(this.filters.rangePicker[1]);
        if (end.getTime() < start.getTime()) {
          this.filters.rangePicker[1] = this.filters.rangePicker[0];
        }
      }
    },
    doSearch() {
      this.$http.post(
        '/analytics/number',
        { number: this.filters.search },
        (data) => {
          this.callback(data);
        },
      );
    },

    today() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
    },
    filterUpdate() {
      if (
        window.location.pathname === '/analytics' &&
        this.filters &&
        this.filters.rangePicker &&
        (!this.filters.rangePicker || this.filters.rangePicker.length === 0)
      ) {
        if (this.visible.date === 'today') {
          const today = this.today();

          this.filters.rangePicker = [today, today];
          this.dateRange = [today, today];

          this.filters.startDate = today;
          this.filters.endDate = today;
        } else {
          return;
        }
      }
      this.validateData();
      this.handleStartTimeChange();
      this.handleEndTimeChange();

      let selectGuid = null;
      const cleanGuid = (guid) =>
        guid.startsWith('call_') ? guid.substring(5) : guid;

      if (this.filters.current_call) {
        if (Array.isArray(this.filters.current_call)) {
          selectGuid = this.filters.current_call.map((item) => {
            const guid = item.guid || item;
            return cleanGuid(guid);
          });
        } else {
          const guid =
            this.filters.current_call.guid || this.filters.current_call;
          selectGuid = cleanGuid(guid);
        }
      }

      let cleanDate = this.filters.rangePicker;
      if (this.dateOnly && Array.isArray(cleanDate)) {
        cleanDate = cleanDate.map((item) => String(item).slice(0, 10));
      }

      let filters = {
        select: selectGuid,
        target: this.filters.target,
        date: this.filters.rangePicker,
        selectedStartTime: this.filters.utcStart || null,
        selectedEndTime: this.filters.utcFinish || null,
        search: this.filters.search,
        searchNickname: this.filters.searchNickname,
        searchManager: this.filters.searchManager,
        active_client: this.filters.visibleManager,
        text: this.filters.text,
        script: this.filters.current_script
          ? this.filters.current_script.guid || this.filters.current_script
          : null,
      };
      // console.log(filters)
      this.$emit('updateFilter', filters);
    },
  },
  mounted() {
    const inf = window.location.hash;
    if (inf.includes('#call_')) {
      const [guid] = inf.replace('#call_', '').split(':');
      //  const name = decodeURIComponent(rawName || '');

      //  const found = this.visible.calls.find(c => c === name || c === guid)
      if (this.visible.callsMultiple) {
        this.filters.current_call = [guid];
      } else {
        this.filters.current_call = guid;
      }
    }
    this.filterUpdate();
  },

  data() {
    let dateRange = [];
    if (this.visible.date == 'today') {
      dateRange = [this.today(), this.today()];
    }

    return {
      menuDate: false,
      dateRange: [],
      filters: {
        startTime: '00:00',
        endTime: '23:59',
        startDate: '',
        endDate: '',
        rangePicker: dateRange,
        utcStart: '',
        utcFinish: '',
        search: '',
        searchNickname: '',
        searchManager: '',
        current_call: null,
        text: '',
        visibleManager: true,
        current_script: null,
      },
    };
  },
  props: {
    visible: Object,
    callback: Function,
    emptyRangeText: {
      type: String,
      default: 'За сегодня',
    },
    callsTitle: {
      type: String,
      default: 'Выберите обзвон',
    },
    callsPlaceholder: {
      type: String,
      default: 'Выберите обзвон',
    },
    callsNoDataText: {
      type: String,
      default: 'Обзвонов нет',
    },
    showExport: {
      type: Boolean,
      default: true,
    },
    dateOnly: {
      type: Boolean,
      default: false,
    },
    detailsLayout: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.input_custom_script {
  width: 185px;
}
.input_custom_call {
  width: 150px;
}
.input_custom_target {
  width: 150px;
}
::v-deep(.v-list-item.v-list-item--active .v-icon) {
  color: #4b5eff !important;
}

/* цвет чекбоксов (если вдруг используются) */
::v-deep(.v-simple-checkbox .v-icon) {
  color: #4b5eff !important;
}
/* ────────────────────  DATE-PICKER  ──────────────────── */
/* ---- Календарь внутри .picker-card ---- */
::v-deep(.picker-card) {
  /* титульная часть (год и «N выбрано») */
  .v-date-picker-title {
    background: #ffffff !important;
    padding: 24px 24px 12px !important;
  }
  .v-date-picker-title__year {
    font: 400 18px/22px 'inherit';
    color: #757575 !important;
  }
  .v-date-picker-title__date,
  .v-date-picker-title__items-selected {
    font: 700 36px/40px 'inherit';
    color: #2b2d33 !important;
  }

  /* шапка с месяцем + стрелками */
  .v-date-picker-header {
    background: #ffffff !important;
    color: #2b2d33 !important;
  }
  .v-date-picker-header .v-btn,
  .v-date-picker-header__value {
    color: #2b2d33 !important;
  }

  /* сами даты */
  .v-date-picker-table--date .v-btn:not(.v-btn--active) {
    background: #ffffff !important;
    color: #2b2d33 !important;
  }
  .v-btn.v-btn--active {
    background: #4b5eff !important;
    color: #2b2d33 !important;
  }
  .v-btn.v-btn--today:not(.v-btn--active) {
    color: #4b5eff !important;
  }

  /* поля времени и кнопка ОК */
  .time-field .v-input__slot {
    background: #ffffff !important;
    border: 2px solid#4B5EFF !important;
    border-radius: 8px !important;
    color: #4b5eff !important;
    font-weight: 400 !important;
  }
  .ok-btn {
    background: #4b5eff !important;
    border: 2px solid #4b5eff !important;
    border-radius: 8px !important;
    color: #ffffff !important;
    font-weight: 600 !important;
  }

  /* защита от auto-white text Vuetify */
  .white--text {
    color: #2b2d33 !important;
  }
}

/* ────────────────────  ФИЛЬТРЫ  ──────────────────── */
.filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff4e8;
  padding: 22px 32px;
  border-radius: 8px 8px 0 0;
}
.no-data-plank {
  padding: 12px;
  opacity: 1;
}
@media (max-width: 800px) {
  .filters {
    flex-direction: column;
    border-radius: 0;
  }
}

.filter {
  display: flex;
  align-items: flex-end;
}
.filter_item {
  display: flex;
  flex-direction: column;
  margin-right: 16px;
}

.wrap_titler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}
.titler {
  font-size: 12px;
  line-height: 14px;
  color: #757575;
}
.clear {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.rel {
  position: relative;
}
.abs {
  position: absolute;
  top: 13px;
  right: 13px;
}
.input_range {
  min-width: 250px;
  width: 360px;
}

.only-successful-with-tip {
  display: flex;
  align-items: baseline;
}
.tip-icon {
  margin-left: 1px;
  cursor: pointer;
  position: relative;
  top: -22px;
}

.apply-btn,
.export-btn {
  background: #ffffff !important;
  border: 1px solid #4b5eff !important;
  border-radius: 8px !important;
  color: #2b2d33 !important;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-transform: none;
  padding: 10px 20px;
}
.apply-btn--disabled,
.export-btn--disabled {
  opacity: 0.5;
  pointer-events: none;
}
::v-deep(.fix-white-title) {
  /* заголовок с годом/«N выбрано» */
  .v-picker__title {
    color: #2b2d33 !important;
  }
  /* внутри него Vuetify вставляет .white--text  →  перебиваем */
  .white--text {
    color: #2b2d33 !important;
  }
}
::v-deep .picker-fix .white--text,
::v-deep .picker-fix .v-picker__title {
  color: #2b2d33 !important;
}
::v-deep .time-field .v-input__slot {
  border: 2px solid #4b5eff !important; /* рамка вокруг всего поля */
  border-radius: 8px !important;
}

.wrap_titler {
  display: flex;
  justify-content: space-between;
}

.clear {
  cursor: pointer;
}

.ranger {
  position: absolute;
}

.rel {
  position: relative;
}

.input_range {
  min-width: 350px;
}

.abs {
  position: absolute;
  top: 13px;
  right: 13px;
  cursor: pointer;
}

.search {
  position: relative;
}

.search_btn {
  right: 10px;
  top: 10px;
}

.apply {
  background: #fff;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  color: #2b2d33;
  padding: 10px 20px;
  margin: 24px 10px 0 5px;
  max-height: 40px;
  cursor: pointer;
}

.btn_sort {
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 120%;
  color: #4b5eff;
}

.btn_sort .icon {
  margin-left: 8px;
}

.filter {
  display: flex;
  position: relative;
}

.calls {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #4b5eff21;
  padding: 22px 32px;
  border-radius: 8px 8px 0 0;
}

.titler {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  color: #404247;
  text-align: left;
  margin-bottom: 6px;
  white-space: nowrap;
}

.filter_item .time-range-picker {
  display: flex;
  margin-right: 10px;
}

.filter_item {
  position: relative;
  display: flex;
  margin-right: 8px;
  display: flex;
  flex-direction: column;
}

.time-input {
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #aaabad;
  border-radius: 6px;
}

@media (max-width: 650px) {
  .filters {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    border-radius: 0;
  }

  .filter {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .filter_item {
    width: 100%;
    margin-right: 0;
    margin-top: 8px;
  }

  .input_range,
  .input_custom,
  .input_custom_call,
  .input_custom_script,
  .input_custom_target {
    min-width: 0;
    width: 100% !important;
  }
  .filter_item.ml-4,
  .filter_item.ml-2 {
    margin-left: 0 !important;
    align-items: center;
    width: 100%;
  }

  .filter_item .v-btn,
  .apply-btn,
  .export-btn {
    width: 150px;
    justify-content: center;
    margin-left: 0 !important;
    margin-top: 8px;
    height: 40px !important;
    padding: 8px 12px;
    font-size: 14px;
  }

  .filter_item:nth-child(n) :deep(.v-input--selection-controls) {
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 400px) {
  .input_range {
    width: 100% !important;
  }
}
.filter_actions {
  display: contents;
}

@media (max-width: 1600px) {
  .filters.details-layout .filter {
    flex-wrap: wrap;
    row-gap: 12px;
  }

  .filters.details-layout .filter_actions {
    display: flex;
    gap: 8px;
    margin-left: auto;
  }

  .filters.details-layout .filter_actions .filter_item,
  .filters.details-layout .filter_actions .v-btn {
    margin-left: 0 !important;
  }
}
@media (min-width: 1024px) and (max-width: 1800px) {
  .filters.details-layout .filter {
    display: grid;
    grid-template-columns: minmax(240px, 2fr) repeat(4, minmax(140px, 1fr));
    gap: 12px 8px;
    width: 100%;
    align-items: end;
  }

  .filters.details-layout .filter_item {
    width: 100%;
    min-width: 0;
    margin: 0;
  }

  .filters.details-layout .input_range,
  .filters.details-layout .input_custom,
  .filters.details-layout .input_custom_call,
  .filters.details-layout .input_custom_script,
  .filters.details-layout .input_custom_target {
    width: 100% !important;
    min-width: 0;
  }

  .filters.details-layout .filter_actions {
    display: flex;
    grid-column: 4 / 6;
    justify-content: flex-end;
    gap: 8px;
  }

  .filters.details-layout .filter_actions .filter_item {
    width: auto;
  }

  .filters.details-layout .filter_actions .v-btn {
    height: 40px !important;
    margin: 0 !important;
  }
}
@media (max-width: 1023px) {
  .filters.details-layout .filter {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    width: 100%;
  }

  .filters.details-layout .filter_range {
    grid-column: 1 / -1;
  }

  .filters.details-layout .filter_item {
    width: 100%;
    min-width: 0;
    margin: 0;
  }

  .filters.details-layout .input_range,
  .filters.details-layout .input_custom,
  .filters.details-layout .input_custom_call,
  .filters.details-layout .input_custom_script,
  .filters.details-layout .input_custom_target {
    width: 100% !important;
    min-width: 0;
  }

  .filters.details-layout .filter_actions {
    display: flex;
    grid-column: 1 / -1;
    gap: 12px;
  }

  .filters.details-layout .filter_actions .filter_item {
    flex: 1;
  }

  .filters.details-layout .filter_actions .v-btn {
    width: 100%;
    height: 40px !important;
    margin: 0 !important;
  }
}
</style>
